import React from 'react'
// @ts-ignore
import classnames from 'classnames'
import { ImageCompoundProps } from './ImageCompound.types'
import { cleanLink } from '@ampdx/common-utils/src'

export const ImageCompound = (props: ImageCompoundProps) => {
  const { imagePosition, src, alt, url, title, shouldGrow } = props
  const cleanedUrl = cleanLink(url ?? '')
  return (
    <figure className={`image-block${shouldGrow ? ' u-flexGrow' : ''}`}>
      {url ? (
        <a className='u-inlineBlock' href={cleanedUrl}>
          <img
            className={classnames({ 'u-sizeFull': imagePosition === 'full' })}
            src={src}
            alt={alt}
            title={title}
          />
        </a>
      ) : (
        <img
          className={classnames({ 'u-sizeFull': imagePosition === 'full' })}
          src={src}
          alt={alt}
          title={title}
        />
      )}
    </figure>
  )
}
